// extracted by mini-css-extract-plugin
export default {"header":"ModuleHeader_header__NntTm"};